<template>
  <div v-if="list_courses.list && list_courses.list.length > 0">
    <v-row>
      <v-col>
        <h3 class="font-weight-bold" v-if="mainStore.parcours_billetterie_mode">
          <v-icon icon="mdi-ticket-outline" color="primary" size="xs-small"></v-icon>
          Les forfaits
        </h3>
        <h3 class="font-weight-bold" v-else>
          <v-icon icon="mdi-routes" color="primary" size="xs-small"></v-icon>
          Les parcours
        </h3>
      </v-col>
    </v-row>
    <CourseItem :course="course" v-for="course in list_courses.list" :key="course.id"></CourseItem>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import CourseItem from "@/components/Home/Courses/Course_Item.vue";
export default {
  components: { CourseItem },
  data() {
    return {

    };
  },
  computed: {
    ...mapStores(useMainStore),
    list_courses() {
      return this.mainStore.module.courses;
    }
  },
};
</script>

<style lang="scss" scoped></style>